"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Partner = void 0;
const common_1 = require("../../common");
const enums_1 = require("../enums");
const partner_address_model_1 = require("./partner-address.model");
const partner_contact_model_1 = require("./partner-contact.model");
class Partner extends common_1.MongoDocument {
}
exports.Partner = Partner;
//# sourceMappingURL=partner.model.js.map